export default __webpack_public_path__ + "static/media/sign_nav.250b56d5.svg";